import {
  SET_IS_DISTANCE_MEASUREMENT_ENABLED,
  SET_IS_KNOWLEDGE_BASE_SIDEBAR_OPEN,
  UI_ERROR,
  UI_LOADING,
} from './types';

export const uiLoading = (boolValue) => (dispatch) => {
  dispatch({ type: UI_LOADING, payload: boolValue });
};

export const uiError = (payload) => (dispatch) => {
  dispatch({ type: UI_ERROR, payload });
};

export const setIsDistanceMeasurementEnabled = (isEnabled) => (dispatch) => {
  dispatch({ type: SET_IS_DISTANCE_MEASUREMENT_ENABLED, payload: isEnabled });
};

export const setIsKnowledgeBaseSidebarOpen = (isOpen) => (dispatch) => {
  dispatch({ type: SET_IS_KNOWLEDGE_BASE_SIDEBAR_OPEN, payload: isOpen });
};
